export default __webpack_public_path__ + "static/media/php.9ffc26f3.svg";